export function areArraysOfStringsNotOrderedDiff(a1, a2) {
  return a1.filter((s1) => !a2.includes(s1)).length > 0 || a1.length !== a2.length;
}



// WEBPACK FOOTER //
// ./src/util/array.js